import { EntityType, IRelation } from '../components/DTStudio/interfaces'
import { findEntityById } from './EntityUtils'

export const getRelationByRelationId = (
    relations: IRelation[],
    relationId: string,
): IRelation | undefined => {
    return relations.find((relation) => relation.id === relationId)
}

export const getRelationByTargetEntityTemplateId = (
    relations: IRelation[],
    targetEntityTemplateId: string,
): IRelation | undefined => {
    return relations.find(
        (relation) => relation.childEntity === targetEntityTemplateId,
    )
}

export const getRelationNameByTargetEntityTemplateId = (
    relations: IRelation[],
    targetEntityTemplateId: string,
): string => {
    return (
        getRelationByTargetEntityTemplateId(relations, targetEntityTemplateId)
            ?.relationName || ''
    )
}

/**
 *
 * @param relations
 * @param targetEntityTemplateId
 * @returns This method will give the nearest relationship to the targetEntityTemplateId.
 * If there is no direct relaitonship to the targetEntityTemplateId, then it will try to get the relationship with the
 * parent entity template of targetEntityTemplateId and so on till it finds a relationship.
 * This arrangement is required because, some times we define, in NetWork Admin -> Entity -> Relations, relationship
 * between entityTemplate-A(Asset) and entityTemplate-B(Sensor).
 * But in Facility Monitoring we are trying to map the relation between an entityInstance entityTemplate-A(Asset)
 * and an entityInstance of a childEntityTemplate(entityTemplate-bb(sub-Sensor)) or
 * grandChildEntityTemplate(entityTemplate-bbb(sub-sub-Sensor)) of entityTemplate-B(Sensor).
 * As a result there won't be a direct relationship between entityTemplate-A(Asset) to entityTemplate-bb(sub-Sensor)
 * and entityTemplate-A(Asset) to entityTemplate-bbb(sub-sub-Sensor).
 */
export const getNearestRelationNameByTargetEntityTemplateId = (
    relations: IRelation[],
    targetEntityTemplateId: string,
    navList: EntityType[],
): string => {
    const entityTemplate: EntityType | undefined = findEntityById(
        navList,
        targetEntityTemplateId,
    ).entity
    const treePath =
        entityTemplate?.treePath.split('/').filter(Boolean).reverse() || []
    let relationName = ''
    for (const item of treePath) {
        relationName = getRelationNameByTargetEntityTemplateId(relations, item)
        if (relationName) {
            break
        }
    }
    return relationName
}
